import React, { useEffect } from 'react';
import scanner1 from '../../assets/images/scanner1.png';
import scanner2 from '../../assets/images/scanner2.png';
import scanner3 from '../../assets/images/scanner3.png';

function SelectDeviceType({setDeviceType,deviceType, setAepsStatus,aepsStatus})  {

	
	useEffect(()  =>{
       if((aepsStatus === 'selectDevice') || (aepsStatus === 'selectDeviceForVerify')){
		  localStorage.setItem("deviceType",deviceType)
	   }
	},[deviceType]);

    return(
		<div className="tab-content-left">
					<h2>Select Device Type</h2>
					<div className="scanner">
						<div className={`scanner1 flex gap-30 ${(deviceType === 'Mantra')?"active":""}`} onClick={() => setDeviceType('Mantra')}>
							<input type="radio" checked={deviceType === 'Mantra'} />
							<div className="device flex">
								<img src={scanner1} alt="Mantra" />
								<p>Mantra</p>
							</div>
						</div>
						<div className={`scanner1 flex gap-30 ${(deviceType === 'Morpho')?"active":""}`}  onClick={() => setDeviceType('Morpho')}>
							<input type="radio" checked={deviceType === 'Morpho'} />
							<div className="device flex">
								<img src={scanner2} alt="Morpho" />
								<p>Morpho</p>
							</div>
						</div>
						<div className={`scanner1 flex gap-30 ${(deviceType === 'Tatvik')?"active":""}`}  onClick={() => setDeviceType('Tatvik')}>
							<input type="radio" checked={deviceType === 'Tatvik'} />
							<div className="device flex">
								<img src={scanner3} alt="Tatvik" />
								<p>Tatvik</p>
							</div>
						</div>
					</div>
					{aepsStatus === 'selectDevice' && (
						<button type="submit" className="button-outline" onClick={() => {setAepsStatus("retailerLogin")}}>
							Process
						</button>
					)}
					{aepsStatus === 'selectDeviceForVerify' && (
						<button type="submit" className="button-outline" onClick={() => setAepsStatus('verifyFingerPrint')}>
							Process
						</button>
					)}
					{aepsStatus === 'selectDeviceForTransaction' && (
						<button type="submit" className="button-outline" onClick={() => setAepsStatus('yes')}>
							Process
						</button>
					)}
				
				</div>
	)
}

export default SelectDeviceType